import { render, staticRenderFns } from "./ComingsoonPage.vue?vue&type=template&id=8913de20&scoped=true"
import script from "./ComingsoonPage.vue?vue&type=script&lang=js"
export * from "./ComingsoonPage.vue?vue&type=script&lang=js"
import style0 from "./ComingsoonPage.vue?vue&type=style&index=0&id=8913de20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8913de20",
  null
  
)

export default component.exports